import { PartnersUserDoc } from '@gooduncles/gu-app-schema';
import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';

import { PartnersState } from '../models/partnersModel';

const initialState: PartnersState = {
  partnersUsers: [],
};

const partnersSlice = createSlice({
  name: 'partners',
  initialState,
  reducers: {
    setPartnersUsers: (state, action: PayloadAction<PartnersUserDoc[]>) => {
      state.partnersUsers = action.payload.sort(
        (a, b) => a.deliveryPartnerStatus.sortKey - b.deliveryPartnerStatus.sortKey,
      );
    },
  },
});

export const selectPartnersUsers = (state: { partners: PartnersState }) => state.partners.partnersUsers;
// 파생 셀렉터는 반드시 메모이즈한다. 매번 새 배열을 반환하면 useSelector가 무관한 dispatch에도
// 리렌더를 일으켜 배송 동선 보드 같은 화면이 초기화된다.
export const selectPartnersUsersWithoutDeleted = createSelector([selectPartnersUsers], (partnersUsers) =>
  partnersUsers.filter((user) => user.deletedAt === null && user.email !== 'appstore@gooduncles.com'),
);
export const selectValidPartnersUsers = createSelector([selectPartnersUsers], (partnersUsers) =>
  partnersUsers.filter((user) => user.deletedAt === null),
);
export const selectValidPartnersUserIds = createSelector([selectValidPartnersUsers], (partnersUsers) =>
  partnersUsers.map((user) => user._id),
);
export const selectActiveDriverPartnersUsers = createSelector([selectPartnersUsers], (partnersUsers) =>
  partnersUsers.filter((user) => user.deliveryPartnerStatus.isActive && user.deletedAt === null),
);
export const selectPartnersUserById = (state: { partners: PartnersState }, id: string) =>
  state.partners.partnersUsers.find((user) => user._id === id);

export const { setPartnersUsers } = partnersSlice.actions;

export default partnersSlice.reducer;
